export const categories = [
  {
    id: 1,
    name: 'Refrigerator',
    image: 'https://images.unsplash.com/photo-1584562187864-4c03b8c23a09?w=300&h=300&fit=crop',
    price: 700,
  },
  {
    id: 2,
    name: 'washing machine',
    image: 'https://images.unsplash.com/photo-1626806787426-5917b4a6c1b8?w=300&h=300&fit=crop',
    price: 700,
  },
  {
    id: 3,
    name: 'WOODEN Cupboard',
    image: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=300&h=300&fit=crop',
    price: 700,
  },
  {
    id: 4,
    name: 'Wooden bed',
    image: 'https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?w=300&h=300&fit=crop',
    price: 700,
  },
  {
    id: 5,
    name: 'Metal Cupboard',
    image: 'https://images.unsplash.com/photo-1595526114035-0d45ed16cfbf?w=300&h=300&fit=crop',
    price: 700,
  },
  {
    id: 6,
    name: 'metal bed',
    image: 'https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=300&h=300&fit=crop',
    price: 700,
  },
  {
    id: 7,
    name: 'Sofa',
    image: 'https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=300&h=300&fit=crop',
    price: 700,
  },
  {
    id: 8,
    name: 'Dinning table',
    image: 'https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=300&h=300&fit=crop',
    price: 700,
  },
  {
    id: 9,
    name: 'TV',
    image: 'https://images.unsplash.com/photo-1593359677879-a4bb92f829d1?w=300&h=300&fit=crop',
    price: 700,
  },
  {
    id: 10,
    name: 'Plastic Chair',
    image: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=300&h=300&fit=crop',
    price: 700,
  },
];

export const productCategories = [
  { id: '1bhk', name: '1 BHK', label: '1 BHK' },
  { id: '2bhk', name: '2 BHK', label: '2 BHK' },
  { id: '3bhk', name: '3 BHK', label: '3 BHK' },
  { id: 'bedroom', name: 'Bedroom', label: 'Bedroom' },
  { id: 'appliances', name: 'Appliances', label: 'Appliances' },
  { id: 'wfh', name: 'WFH', label: 'WFH' },
  { id: 'living', name: 'Living', label: 'Living' },
  { id: 'kitchen', name: 'Kitchen', label: 'Kitchen' }
];

export const budgetRanges = [
  { id: 'under-1000', label: 'Under ₹1,000', min: 0, max: 1000 },
  { id: '1000-2000', label: '₹1,000 - ₹2,000', min: 1000, max: 2000 },
  { id: '2000-3000', label: '₹2,000 - ₹3,000', min: 2000, max: 3000 },
  { id: '3000-5000', label: '₹3,000 - ₹5,000', min: 3000, max: 5000 },
  { id: 'above-5000', label: 'Above ₹5,000', min: 5000, max: Infinity }
];

export const plans = [
  {
    id: 1,
    name: 'Lite',
    products: 6,
    price: 2699,
  },
  {
    id: 2,
    name: 'Premium',
    products: 9,
    price: 3999,
  },
  {
    id: 3,
    name: 'Luxury',
    products: 12,
    price: 4999,
  },
];